<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from "echarts";// echarts theme
import resize from "@/mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Number,
      // required: true,
    },
    index:{type: Number}
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData,this.name);
    },
    setOptions(chartData) {
      let opt = Math.round((chartData*100)*100)/100
      let color = ['#3673E8','#FFCF5F','#5FD5EC']
      this.chart.setOption({
        title: {
          text:opt+"%",
          x: "center",
          y: "center",
          textStyle: {
            color: "#fff",
            fontSize: 18,
          },
        },
        series: [
          {
            type: "pie",
            name: "main",
            silent: true,
            radius: ["50%", "60%"],
            label: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: opt,
                itemStyle: {
                  normal: {
                    color: color[this.index],
                  },
                },
              },
              {
                value: 100-opt,
                itemStyle: {
                  normal: {
                    color: 'transparent',
                  },
                },
              },
            ],
          },
        ],
      });
    },
  },
};
</script>
